import { useModal } from 'shared/hooks';

export const makeModalsHook = <T extends string>(
  ...modals: T[]
): (() => Record<T, ReturnType<typeof useModal>>) => () =>
  modals.reduce(
    (prev, curr) => ({ ...prev, [curr]: useModal() }),
    {} as Record<T, ReturnType<typeof useModal>>,
  );
